import type { LogicalBounds } from '../../../shared/layout/index.js';

/** Alpha bounds measured from the approved canonical 1086x1448 Cosmo PNG. */
export const DISCOVERY_LAB_COSMO_OPAQUE_BOUNDS = {
  sourceHeight: 1448,
  bottomExclusive: 1429,
} as const;

export function calculateRightBoundedTextX(
  safe: LogicalBounds,
  renderedWidth: number,
  inset: number,
) {
  const safeInset = Math.max(0, inset);
  const width = Math.max(0, renderedWidth);
  return Math.max(safe.x + safeInset, safe.right - safeInset - width);
}

/**
 * Places an originY=1 image so its measured opaque content, rather than its
 * source rectangle, ends at the requested safe-area margin.
 */
export function calculateOpaqueImageBaseline(
  safeBottom: number,
  displayHeight: number,
  sourceHeight: number,
  opaqueBottomExclusive: number,
  margin: number,
) {
  const validSourceHeight = Math.max(1, sourceHeight);
  const clampedOpaqueBottom = Math.min(
    validSourceHeight,
    Math.max(0, opaqueBottomExclusive),
  );
  const transparentBottomRatio = 1 - clampedOpaqueBottom / validSourceHeight;
  return safeBottom - Math.max(0, margin) + Math.max(0, displayHeight) * transparentBottomRatio;
}

export function calculateOpaqueImageBottom(
  baseline: number,
  displayHeight: number,
  sourceHeight: number,
  opaqueBottomExclusive: number,
) {
  const validSourceHeight = Math.max(1, sourceHeight);
  const clampedOpaqueBottom = Math.min(
    validSourceHeight,
    Math.max(0, opaqueBottomExclusive),
  );
  return baseline - Math.max(0, displayHeight)
    + Math.max(0, displayHeight) * clampedOpaqueBottom / validSourceHeight;
}
